import React, { Fragment } from 'react';
import classNames from 'classnames';
import { Tooltip } from '@cimpress/react-components';
const withTooltip = (tooltip, content) => {
    if (!tooltip) {
        return content;
    }
    return React.createElement(Tooltip, { contents: tooltip }, content);
};
const clickHandler = (userHandler, key) => {
    return () => {
        userHandler();
    };
};
export const DefaultButton = (props) => {
    const baseButton = (React.createElement("button", { autoFocus: !!props.autoFocus, className: classNames('rct-default-button', 'btn', { 'btn-sm': props.size === 'sm' }, { 'btn-lg': props.size === 'lg' }, `btn-${props.type}`, { disabled: props.disabled }), onClick: props.disabled ? undefined : clickHandler(props.onClick, props.gaKey) },
        props.icon && React.createElement(Fragment, null,
            React.createElement(props.icon, null),
            "\u00A0\u00A0"),
        props.title || props.children));
    if (props.disabled && props.disabledTooltip) {
        return withTooltip(props.disabledTooltip, baseButton);
    }
    if (props.tooltip) {
        return withTooltip(props.tooltip, baseButton);
    }
    return baseButton;
};
//# sourceMappingURL=DefaultButton.js.map